
namespace TabAurous.SalesOrder{

    @Serenity.Decorators.registerClass()
    export class SalesOrderItemsGrid extends Serenity.EntityGrid<SalesOrderItemsRow, any> {
        protected getColumnsKey() { return 'SalesOrder.SalesOrderItems'; }
        protected getDialogType() { return SalesOrderItemsDialog; }
        protected getIdProperty() { return SalesOrderItemsRow.idProperty; }
        protected getInsertPermission() { return SalesOrderItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return SalesOrderItemsRow.localTextPrefix; }
        protected getService() { return SalesOrderItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
       
        }
        
    }
}